import $ from 'jquery';
import './loading.less'

interface InlineLoadingOptions {
    ratio?: number;
    message?: string;
    compact?: boolean;
}

export default class Loading {

    static show(message: string) {
        var loadingContainer = $('body > .loading-container');
        if (!loadingContainer.length) {
            loadingContainer = $('<div class="loading-container"/>');
            loadingContainer.html('<div uk-spinner="ratio: 3"></div>');
            loadingContainer.append('<div class="content-message"></div>');
            $('body').prepend(loadingContainer);
        }

        Loading.updateMessage(message);
        loadingContainer.fadeIn(200);
    }

    static hide() {
        if ($(document).data('manual') !== true)
            $('body > .loading-container').fadeOut(200);

        $(document).data('manual', false);
    };

    static ignoreNextAjaxLoading = function (manual) {
        $(document).data('showLoading', false);
        $(document).data('manual', manual || false);
    };

    static updateMessage(message) {
        $('body > .loading-container').find('.content-message').html(message || '');
    };

    static inline(options: InlineLoadingOptions = {}) {
        const ratio = options.ratio || 2;
        const compactClass = options.compact ? ' loading-inline--compact' : '';
        const message = options.message
            ? `<div class="loading-inline__message">${Loading.escapeHtml(options.message)}</div>`
            : '';

        return `<div class="loading-inline${compactClass}"><span uk-spinner="ratio: ${ratio}"></span>${message}</div>`;
    }

    static showInline($input, options: InlineLoadingOptions = {}) {
        $input.html(Loading.inline(options));
    }

    static showDivLoading($input) {
        Loading.showInline($input, { ratio: 3, compact: true });
    }

    private static escapeHtml(value: string) {
        return $('<div/>').text(value).html();
    }
}
